import { render, staticRenderFns } from "./SingleChoiceElementSettings.vue?vue&type=template&id=08155412&scoped=true&"
import script from "./SingleChoiceElementSettings.vue?vue&type=script&lang=ts&"
export * from "./SingleChoiceElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08155412",
  null
  
)

export default component.exports